import script from "./paid-invoices.vue?vue&type=script&setup=true&lang=js"
export * from "./paid-invoices.vue?vue&type=script&setup=true&lang=js"

import "./paid-invoices.vue?vue&type=style&index=0&id=0c64d212&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c64d212"]])

export default __exports__